import _pick from 'lodash/pick';

function Ctrl($scope, $rootScope, $state, $timeout, $uibModalInstance, utilsService, jsSdkUser, imageService, dateUtilsService) {
  $scope.user = $scope.currentUser;

  $scope.selectedGender = $scope.currentUser.gender;

  if ($scope.currentUser.gender !== 'male' && $scope.currentUser.gender !== 'female') {
    $scope.selectedGender = 'custom';
  }

  $scope.birthday = new Date($scope.currentUser.birthday);

  $scope.saveUser = function() {
    $scope.user.birthday = dateUtilsService.toUTCTimestampWithoutTime($scope.birthday);

    const user = _pick($scope.user, ['name', 'birthday', 'gender']);

    jsSdkUser.updateMe(user)
      .then(updatedUser => {
        $scope.user = updatedUser;
        $scope.updateUserResult = 'success';
        $scope.isUpdatingUser = false;

        $uibModalInstance.dismiss('cancel');
      })
      .catch(() => {
        $scope.updateUserResult = 'error';
        $scope.isUpdatingUser = false;
      });
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.isUpdatingUser = null;
  $scope.updateUserResult = null;
  $scope.updateUserBtnOptions = {
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonDefaultText: 'Save Profile',
    buttonSubmittingText: 'Saving Changes...',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonSuccessText: 'Changes Saved',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonErrorText: 'Error Saving Changes',
    buttonErrorClass: 'animated-button-error'
  };

  // ---------------------- Update Profile Pic --------------- //

  $scope.isSubmittingProfilePic = null;
  $scope.profilePicResult = null;
  $scope.profilePicBtnOptions = {
    buttonInitialIcon: 'icon-left fa fa-image',
    buttonSubmittingIcon: 'icon-left fa fa-spin fa-refresh',
    buttonDefaultText: 'Change Avatar',
    buttonDefaultIcon: 'icon-left fa fa-image',
    buttonSubmittingText: 'Saving Profile Pic...',
    buttonSuccessIcon: 'icon-left fa fa-check',
    buttonSuccessText: 'Profile Pic Updated',
    buttonErrorIcon: 'icon-left fa fa-remove',
    buttonErrorText: 'Error Uploading Profile Pic',
    buttonErrorClass: 'animated-button-error'
  };

  $scope.updateProfilePic = function(files) {
    $scope.isSubmittingProfilePic = true;
    $scope.profilePicResult = null;

    return imageService.upload(files[0], {
        size: 'smallSquare'
      })
      .then(function success(response) {
        jsSdkUser.updateMe({
          imageUrl: response.smallSquare
        }, function successUpdatingUser(response2) {
          $scope.profilePicResult = 'success';
          $scope.currentUser.imageUrl = response2.imageUrl;
          $scope.isSubmittingProfilePic = false;
        }, function errorUpdatingUser() {
          $scope.profilePicResult = 'error';
          $scope.isSubmittingProfilePic = false;
        });

      }, function error(response) {

        $scope.errorUploadingPicMsg = response;
        $scope.profilePicResult = 'error';
        $scope.isSubmittingProfilePic = false;
      });
  };
}

Ctrl.$inject = [
  '$scope',
  '$rootScope',
  '$state',
  '$timeout',
  '$uibModalInstance',
  'utilsService',
  'jsSdk.user',
  'tl.image.service',
  'dateUtilsService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/services/modal/editProfile/editProfileModalCtrl.js